import { LogoutOutlined } from '@ant-design/icons';
import { Button, Card, Result, Typography } from 'antd';
import { Navigate } from 'react-router-dom';
import { hasActivationContinuation, hasPendingOnboarding, hasRecoverableAdminOnboarding } from 'services/auth/onboardingStatus';
import useAuthRepo from 'services/repo/useAuthRepo';
import LocalStorageUtils from 'utils/LocalStorage';

export default function GetStartedPage() {
  const { isLoading, logout } = useAuthRepo(false);
  const isAuthenticated = Boolean(LocalStorageUtils.jwtToken.get());
  const user = LocalStorageUtils.userInfo.get() || {};
  const signedInEmail = sessionStorage.getItem('workplansiq.signedInEmail')
    || user.email
    || user.emailAddress
    || user.preferred_username
    || user.username;

  if (!isAuthenticated) return <Navigate to="/" replace />;
  if (hasPendingOnboarding(signedInEmail)
    || hasActivationContinuation(signedInEmail)
    || hasRecoverableAdminOnboarding(signedInEmail)) {
    return <Navigate to="/welcome" replace />;
  }

  return (
    <main className="onboarding-page">
      <div className="onboarding-shell">
        <header className="onboarding-header">
          <div>
            <Typography.Text className="onboarding-eyebrow">WORKPLANSIQ</Typography.Text>
            <Typography.Title level={2}>Organization access</Typography.Title>
            <Typography.Paragraph type="secondary">
              Your account is signed in, but no organization access is available yet.
            </Typography.Paragraph>
          </div>
          <Button danger icon={<LogoutOutlined />} loading={isLoading} onClick={logout}>Logout</Button>
        </header>

        <Card className="onboarding-card">
          <Result
            status="info"
            title="No organization access yet"
            subTitle="We could not match this account to an organization, invitation, or existing subscription setup. Please contact your administrator or WorkPlansIQ support."
          />
        </Card>
      </div>
    </main>
  );
}
